var bundlePricing = false;
var bundlePrice = 0;

/* Noticed Ajax Add To Cart, Cart Drawer */
function ntcCartDrawerOpen() {
  bundlePricingCheck();
  $('body').addClass('cart-drawer-open');
  $('#cart-drawer').attr('hidden',false);

  $('#cart-drawer').animate({right: '0'},450);

  // Set focus
  if($('#cart-drawer .cart-item--empty').length > 0){
    $('.cart-drawer__close').focus();
  } else {
    $('#cart-drawer .cart-drawer__items input[type="number"]').first().focus();
  }
}

var cartTotalFormatted;

function bundlePricingCheck(){
  if(bundlePricing){
    document.querySelector(".cart-drawer__checkout").style.display = "none";
    document.querySelector(".cart-drawer__checkout.viewCart").style.display = "block";
  }else{
    document.querySelector(".cart-drawer__checkout").style.display = "block";
    document.querySelector(".cart-drawer__checkout.viewCart").style.display = "none";
  }
}

function ntcUpdateCartData_Drawer(cartQty,cartTotal){
  cartTotalFormatted = theme.Currency.formatMoney(cartTotal,theme.moneyFormat);
  if(bundlePricing){
    cartTotalFormatted = theme.Currency.formatMoney(bundlePrice,theme.moneyFormat);
  }
  document.querySelector(".cartCost ").innerHTML = "(<span class='money'>" + cartTotalFormatted + "</span>)"
  $('#CartCount span:not(.icon__fallback-text)').text(cartQty);
  if(cartQty > 0){
    $('#CartCount').removeClass('hide');
  } else {
    $('#CartCount').addClass('hide');
  }

  var atcSuccess = false;
  ntcGetCartItems_Drawer(atcSuccess);

  // $('.cart-drawer__subtotal').text(cartTotalFormatted).removeClass('updating');

  // A11y aria-live announcement
  var successMsg = (cartQty === 1) ? 'There is now 1 item in your cart.' : 'There are now ' + cartQty + ' items in your cart.';
  $('[data-cart-status]').text(successMsg);

  if($('.ab-motivator').length) {
    ntcUpdateMotivator_Drawer(cartQty,cartTotal);
  }
  bundlePricingCheck();
}

function ntcUpdateCartDrawer(cartItems,atcSuccess,atcAddedQty){
  bundlePrice = 0;
  if(cartItems.length !== 0) {
    $('.cart-drawer__items').html('');
    for (i = 0; i < cartItems.length; i++){
      var item = cartItems[i];
      var line = i + 1;
      var itemImg = item.image;
      if(itemImg !== null){
        itemImg = itemImg.replace(/(\.[^.]*)$/, "_100x100$1");
      }
      var itemPrice = '<span class="cart-item__price">' + theme.Currency.formatMoney(item.price,theme.moneyFormat) + '</span>';
      try{
        if(item.properties._bundle_price == null){
          bundlePrice += item.final_line_price;
        }
      }catch(e){
        bundlePrice += item.final_line_price;
      }
      var itemVariantTitle = (item.variant_title == null) ? '' : '<br><small>' + item.variant_title + '</small>';
      var itemProperties = "";
      try{
        if(item.properties){
          for (const [key, value] of Object.entries(item.properties)) {
            if(key.length == 1){
              itemProperties += `<p class='item-prop'>${value}</p>`;
            }
          }
          if(item.properties._bundle_price){
            bundlePrice += item.properties._bundle_price * item.quantity;
            itemPrice = '<span class="cart-item__price">' + theme.Currency.formatMoney(item.properties._bundle_price,theme.moneyFormat) + '</span>';
            bundlePricing = true;
          }
        }
      }catch(e){
        bundlePrice += item.price;
      }
      var itemRemove = '<button class="cart-item__remove btn--link cancel-link" aria-label="Remove '+ item.title +' from your cart">Remove</button>';
      var itemQty = '<div class="cart-item__qty"><label class="visually-hidden" for="cart-item-'+ line +'-qty-input">Quantity of '+ item.title +'</label><input id="cart-item-'+ line +'-qty-input" class="cart-item__qty-input" type="number" value="' + item.quantity + '">' + itemRemove + '</div>';
      var itemHtml = '<div class="cart-item" data-line="' + line + '" data-handle="' + item.handle + '" data-id="' + item.id + '"><div class="cart-item__image"><a href="' + item.url + '"><img src="'+itemImg + '"></a></div><div class="cart-item__product"><a class="cart-item__title" href="' + item.url + '">' + item.product_title + itemVariantTitle + '</a>' + itemProperties + itemPrice + '</div>' + itemQty + '</div>';
      $('.cart-drawer__items').append(itemHtml);
    }
    $('.cart-item--empty, .cart-drawer .form-message').remove();
    $('.cart-drawer__buttons').removeClass('hide');
  }
  if(atcSuccess) {
    var itemPlural = (atcAddedQty === 1) ? '':'s';
    var successMsg = atcAddedQty + ' item' + itemPlural + ' successfully added to your cart!';
    $('.cart-drawer__header').append('<div class="form-message form-message--success text-center">' + successMsg + '</div>');
    // A11y aria-live announcement
    $('[data-cart-add-status]').text(successMsg);
  }

  if(bundlePricing){
    cartTotalFormatted = theme.Currency.formatMoney(bundlePrice,theme.moneyFormat);
  }
  $('.cart-drawer__subtotal').text(cartTotalFormatted).removeClass('updating');

  ntcCartDrawerOpen();
  bundlePricingCheck();
}

function ntcUpdateMotivator_Drawer(cartQty,cartTotal){
  var motivatorMin = parseInt($('.ab-motivator').data('min'));
  var motivatorReward = $('.ab-motivator').data('reward');
  var motivatorMsg;
  if(cartTotal >= motivatorMin) {
    motivatorMsg = $('.ab-motivator').data('qualifies');
    $('.ab-motivator__text').html(motivatorMsg);
    $('.ab-motivator').removeClass('ab-motivator--not-qualifies').addClass('ab-motivator--qualifies');
  } else {
    var motivatorNeed = motivatorMin - cartTotal;
    motivatorMsg = 'You are <strong class="ab-motivator__need">' + theme.Currency.formatMoney(motivatorNeed,theme.moneyFormat) + '</strong> away from ' + motivatorReward + '.';
    $('.ab-motivator__text').html(motivatorMsg);
    $('.ab-motivator').removeClass('ab-motivator--qualifies').addClass('ab-motivator--not-qualifies');
  }

  // A11y aria-live announcement
  $('[data-ab-status]').html(motivatorMsg);

  if(cartQty == 0) {
    $('.ab-motivator--cart-drawer').addClass('hide');
  } else {
    $('.ab-motivator--cart-drawer').removeClass('hide');
  }
}

function ntcGetCartItems_Drawer(atcSuccess,atcAddedQty){
  $.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart) {
      // console.log(cart);
      var cartItems = cart.items;
      var cartTotal = cart.total_price;
      ntcUpdateCartDrawer(cartItems,atcSuccess,atcAddedQty);
      if(atcSuccess) {
        var cartQty = cart.item_count;
        ntcUpdateCartData_Drawer(cartQty,cartTotal);
      }
    }
  });
}


$(function(){

    // BEGIN Cart Drawer

    // EVENTS
    // Header cart link click
    $('.cart-text-link a').click(function(e){
      e.preventDefault();
      var atcSuccess = false;
      ntcGetCartItems_Drawer(atcSuccess);
    });

    // Header cart mobile
    $('.mobile-wrapper .CartToggle').click(function(e){
      e.preventDefault();
      var atcSuccess = false;
      ntcGetCartItems_Drawer(atcSuccess);
    });

    // Add to Cart PDP button click
    $('body').on('click','#AddToCart-product',function(e){
      e.preventDefault(); 
      var $atcForm = $(this).closest('form');
      var formData = $atcForm.serialize();
      var atcAddedQty = parseInt($atcForm.find('[name="quantity"]').val() || 1);
      ntcAjaxAdd(formData,atcAddedQty,$atcForm);
    });

  
  // Add to Cart PDP button click
  $('body').on('click','.all_add_to_cart',function(e){
    e.preventDefault();
    $('.error_custom').remove();
    var is_chechked = 0;
    $('.product-accordian-wraper .set.is_required').each(function(){
      if($(this).find('.add_to_bundle.remove_btn_main').length == 0){
        is_chechked++;
        $(this).before('<p class="error_custom">Please Select One Product</p>');
      }
    });
    if(is_chechked > 0){
      $('html, body').animate({
        scrollTop: $('.error_custom').first().offset().top
      }, 2000);
      return false;
    }

    var bundle_id = Math.random() * 100000000000000000;
    var $atcForm = $('.bundle-footer-row');
    var data = [];
    $('.bundle-row').each(function(i,v){
      var items = {};
      items.id = $(this).attr('data-id');
      items.quantity = 1;
      var prop = {};
      if($('.bundle-row').length > 1){
        prop['Bundle Id'] = bundle_id; 
      }
      items.properties = prop;
      data.push(items);
    });
    if(data.length == 0){
      $('.bundle-details-wrapper').before('<p class="error_custom">Please Select One Product</p>');
      $('html, body').animate({
        scrollTop: $('.error_custom').first().offset().top
      }, 2000);
      return false;
    }
    $.post('/cart/add.js', {
      items: data
    }, function(crt){
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
          var atcSuccess = true;
          var atcAddedQty = $('.bundle-row').length;
          // console.log(cart);
          var cartItems = cart.items;
          var cartTotal = cart.total_price;
          ntcUpdateCartDrawer(cartItems,atcSuccess,atcAddedQty);
          if(atcSuccess) {
            var cartQty = cart.item_count;
            ntcUpdateCartData_Drawer(cartQty,cartTotal);
          }
        }
      });
    },'JSON').fail(function(response) {
      console.log('Something went wrong...');
    });
  });
  
    // Add to Cart collection button click
    $('body').on('click','#AddToCart-ntc-quick-view',function(e){
      e.preventDefault();
      var $atcForm = $(this).closest('form');
      var formData = $atcForm.serialize();
      var atcAddedQty = 1;
      ntcAjaxAdd(formData,atcAddedQty,$atcForm);
      try{ntcTriggerModalClose();}catch(e){}
    });

    // Click to close drawer
    $('.cart-drawer__close').click(function(){
      ntcCartDrawerClose();
    });

    $('body').click(function(e){
      if($(this).hasClass('cart-drawer-open')){
        if(e.target.id !== "cart-drawer" && $(e.target).closest('#cart-drawer').length === 0) {
          ntcCartDrawerClose();
        }
      }
    });

    $(document).keyup(function(e){
      if(e.keyCode == 27 && $('body').hasClass('cart-drawer-open')){
        ntcCartDrawerClose();
      }
    });

    // Update item quantity
    function ntcEnableInput($cartItem){
      setTimeout(function(){
        $cartItem.find('.cart-item__qty-input').removeClass('disabled').prop('disabled',false).focus();
      },500);
    }

    function ntcDisableInput(el){
      $(el).addClass('disabled').prop('disabled',true);
    }

    function ntcCartDrawerInputChange(el){
      ntcDisableInput(el);

      var $cartItem = $(el).closest('.cart-item');
      var line = $cartItem.data('line');
      var qty = parseInt($(el).val());
      var handle = $cartItem.data('handle');
      var id = $cartItem.data('id');

      ntcCartDrawerItemEdit(line,qty,handle,id,$cartItem);
    }

    $('body').on('input','.cart-item__qty-input:not(.disabled)',function(e){
      var el = this;
      ntcCartDrawerInputChange(el);
    });

    // Disable scroll on qty inputs
    $('.cart-drawer__qty-input').on('focus',function(e) {
      $(this).on('mousewheel.disableScroll',function(e) {
        e.preventDefault()
      })
    });
    $('.cart-drawer__qty-input').on('blur',function(e) {
      $(this).off('mousewheel.disableScroll')
    });

    // Remove item from cart
    $('body').on('click', '.cart-item__remove',function(){
      var line = $(this).closest('.cart-item').data('line');
      var qty = 0;
      var handle = null;
      ntcCartDrawerItemEdit(line,qty,handle);
    });


    // FUNCTIONS
    function ntcAjaxAddSuccess(atcSuccess,atcAddedQty){
      try{ntcTriggerModalClose();}catch(e){}
      if($('body').hasClass('template-cart')) {
        location.reload();
      } else {
        ntcGetCartItems_Drawer(atcSuccess,atcAddedQty);
      }
    }

    function ntcAjaxAdd(formData,atcAddedQty,$atcForm){
      if($atcForm){
        $atcForm.find('.form-message').remove();
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function(item){
          var atcSuccess = true;
          ntcAjaxAddSuccess(atcSuccess,atcAddedQty);
        },
        error: function(response){
          if(response.status == 422){
            $atcForm.append('<div class="form-message form-message--error" role="alert">' + response.responseJSON.description + '</div>');
            // A11y aria-live announcement
            $('[data-cart-add-status]').text(response.responseJSON.description);
          } else {
            console.error(response);
          }
        }
      });
    }

    function ntcCartDrawerClose() {
      $('#cart-drawer').animate({right: '-100%'},450, function() {
        $('body').removeClass('cart-drawer-open');
        $('#cart-drawer').attr('hidden',true);
        //$('.site-header__cart').focus();
        $('.cart-drawer .form-message, .cart-drawer .cart-item.to-remove').remove();
      });
    }

    function ntcTriggerModalClose() {
      $.fancybox.close();
    }

    function ntcCartDrawerItemEdit(line,qty,handle,id,$cartItem){
      $('.cart-drawer__subtotal').addClass('updating');

      $('.cart-drawer .form-message').animate({opacity: 0}, 200, function(){
        $(this).slideUp(function(){
          $(this).remove();
        });
      });

      if(qty !== 0) {
        $.get('/products/'+handle+'?view=inventory',function(response) {
          var data = JSON.parse(response);
          var invQty;
          var invMgmt;
          var invProblem = false;

          for (i = 0; i < data.length; i++){
            var variant = data[i];
            if(variant.id == id) {
              invMgmt = variant.inventory_management;
              if(invMgmt !== null){
                var invPolicy = variant.inventory_policy;
                invQty = variant.inventory_quantity;
                if(invPolicy == 'deny' && qty > invQty) {
                  invProblem = true;
                  qty = invQty;
                }
              }
              break;
            }
          }

          if(invProblem) {
            var invProblemMsg = 'Sorry, we only have ' + invQty + ' in stock right now.';
            $cartItem.append('<div id="line-'+ line +'-error" class="form-message form-message--error">' + invProblemMsg + '</div>');
            setTimeout(function(){
              $('#line-'+ line +'-error').slideUp(function(){
                $(this).remove();
              });
            },3000);
            // A11y aria-live announcement
            $('[data-cart-add-status]').text(invProblemMsg);

            $('.cart-drawer .cart-item[data-id="' + id + '"] .cart-item__qty-input').val(invQty);
          }

          ntcCartDrawerItemChange(line,qty,$cartItem);

        });
      } else {
        // remove item
        ntcCartDrawerItemChange(line,qty,$cartItem);
      }
    }

    function ntcCartDrawerItemChange(line,qty,$cartItem){
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        async: false,
        cache: false,
        data: 'line=' + line + '&quantity=' + qty,
        dataType: 'json',
        success: function(cart){
          if(qty == 0) {
            $('.cart-drawer .cart-item[data-line="' + line + '"]').slideUp(function(){
              $(this).addClass('to-remove').attr('data-line','');
              $('.cart-drawer .cart-item:not(.to-remove):not(.cart-item--empty)').each(function(i){
                var newline = i + 1;
                $(this).attr('data-line',newline);
              });
            });
          } else {
            ntcEnableInput($cartItem);
          }
          var cartQty = cart.item_count;
          var cartTotal = cart.total_price;
          ntcUpdateCartData_Drawer(cartQty,cartTotal);

          if(cartQty == 0) {
            var emptyHtml = '<div class="cart-item cart-item--empty">Your cart is currently empty.</div>';
            $('.cart-drawer__items').append(emptyHtml);
            $('.cart-drawer__buttons').addClass('hide');
          }
        },
        error: function(response){
          if(response.status == 422){
            ntcEnableInput($cartItem);
            $cartItem.append('<div class="form-message form-message--error" role="alert">' + response.responseJSON.description + '</div>');
            // A11y aria-live announcement
            $('[data-cart-add-status]').text(response.responseJSON.description);
          } else {
            console.error(response);
          }
        }
      });
    }

    // END Cart Drawer

    document.querySelector('.upsell-cta').addEventListener("click", addUpsell);

    function addUpsell(){
    	$.ajax({
    		type: 'POST',
    		url: '/cart/add.js',
    		data:{
    			items: [
    				{
    					quantity: 1,
    					id: upsellItemID
    				}
    			]
    		},
    		dataType: 'json',
    		success: function(item){
    			var atcSuccess = true;
    			ntcAjaxAddSuccess(atcSuccess,1);
    		},
    		error: function(response){
    			if(response.status == 422){
    			} else {
    				console.error(response);
    			}
    		}
    	});
    }


});
